import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { registerServiceWorker, initializeOfflineDetection } from './utils/serviceWorker';

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  registerServiceWorker().catch((error) => {
    console.error('Failed to register service worker:', error);
  });
}

// Initialize offline detection
initializeOfflineDetection();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
